import React, { PropTypes } from 'react';
import { FormControl, Col, ControlLabel, FormGroup } from 'react-bootstrap';

const Mobile = (props) => {
  return (
    <FormGroup controlId="mobile">
      <Col componentClass={ControlLabel} sm={5}>
        Mobile
      </Col>
    <Col sm={7}>
        <FormControl type="text" value={props.mobile} onChange={props.handleChangeMobile}
          autoComplete="off" />
    </Col>
    </FormGroup>
  )
}

Mobile.propTypes = {
  mobile: PropTypes.string,
  handleChangeMobile: PropTypes.func
};

export default Mobile;



// WEBPACK FOOTER //
// ./src/app/components/mobile/Mobile.js